export default __webpack_public_path__ + "static/media/post-03-detail.c3063246.jpg";